import {DatatableColumn} from '../model/column/datatable-column';
import {ActionColumn, IconConfig} from '../model/column/action-column';
import {SelectColumn} from '../model/column/select-column';
import {ColumnTypeEnumeration} from '../model/column/column-type.enumeration';
import {AlignColumnsEnumeration} from '../model/column/align-columns.enumeration';

export class ColumnBuilder {
  static create(name: string, label: string, searchable?: boolean, alignment?: AlignColumnsEnumeration): DatatableColumn {
    return new DatatableColumn(name, label, searchable, ColumnTypeEnumeration.TEXT_COLUMN, alignment);
  }

  static createHidden(name: string): DatatableColumn {
    const column = new DatatableColumn(name, '');
    column.visible = false;
    column.sortable = false;
    return column;
  }

  static createDate(name: string, label: string, searchable?: boolean, alignment?: AlignColumnsEnumeration): DatatableColumn {
    const align = alignment ? alignment : AlignColumnsEnumeration.ALIGN_RIGHT;
    return new DatatableColumn(name, label, searchable, ColumnTypeEnumeration.DATE_COLUMN, align);
  }

  static createCheckbox(): DatatableColumn {
    const column = new DatatableColumn('checkbox', '', false, ColumnTypeEnumeration.CHECKBOX_COLUMN);
    column.sortable = false;
    return column;
  }

  static createAction(name: string, label: string, onClick: (rowData: any) => void, iconConfig: IconConfig, isVisible?: (rowData: any) => boolean,): ActionColumn {
    return new ActionColumn(name, label, onClick, iconConfig, isVisible);
  }

  static createSelect(name: string, label: string, enumeration: any, multiple?: boolean, alignment?: AlignColumnsEnumeration): SelectColumn {
    return new SelectColumn(name, label, enumeration, multiple, alignment);
  }

  static createNumber(name: string, label: string, searchable?: boolean, alignment?: AlignColumnsEnumeration): DatatableColumn {
    return new DatatableColumn(name, label, searchable, ColumnTypeEnumeration.NUMBER_COLUMN, alignment);
  }
}
